import { useEffect, useRef, useState } from 'react'
import { MatrixEvent } from 'matrix-js-sdk'
import ResizeNotifier from 'matrix-react-sdk/lib/utils/ResizeNotifier'
import { useSelector } from 'react-redux'
import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import { sleep } from 'util/functions'
import { getMatrixClient } from 'ducks/chat/utils/client'

const resizeNotifier = new ResizeNotifier()
export default function useShadowEvent(mxEvent) {
  const unmounted = useRef(false)
  const [, setCurrentEvent] = useState(mxEvent)
  const accountChatRoomId = useSelector(selectAccountChatRoomId)
  useEffect(
    () => {
      const isShadowEvent =
        mxEvent && mxEvent.getContent()?.msgtype === 'g.shadow'
      if (isShadowEvent) {
        findShadowEvent(accountChatRoomId, mxEvent, setCurrentEvent, unmounted)
      }
    },
    [accountChatRoomId, mxEvent]
  )
  return mxEvent
}

async function loadShadowEvent(room, eventId) {
  try {
    const client = getMatrixClient()
    const event = await client.fetchRoomEvent(room.roomId, eventId)
    if (event) {
      const matrixEvent = new MatrixEvent(event)
      room.addLiveEvents([matrixEvent], 'ignore')
      return matrixEvent
    }
  } catch (error) {
    // Supress errors
  }
  await sleep(100)
  return null
}

async function findShadowEvent(
  accountChatRoomId,
  mxEvent,
  setCurrentEvent,
  unmounted,
  attempt = 0
) {
  if (unmounted.current) return
  if (!mxEvent) return
  if (mxEvent.replacingEvent()) return
  const { event_id: eventId } = mxEvent.getContent()
  if (attempt > 10) return
  if (!eventId) return
  const client = getMatrixClient()
  const room = client.getRoom(accountChatRoomId)
  const shadowMxEvent = await room.findEventById(eventId)
  if (shadowMxEvent) {
    mxEvent.makeReplaced(shadowMxEvent)
    setCurrentEvent(shadowMxEvent)
    resizeNotifier.notifyWindowResized()
  } else {
    await loadShadowEvent(room, eventId)
    await findShadowEvent(
      accountChatRoomId,
      mxEvent,
      setCurrentEvent,
      unmounted,
      attempt + 1
    )
  }
}
